import { MEMBER_TYPE_NORMAL, MEMBER_TYPE_TEACHER } from '@/store/types'

// Set current selected library as default library
const state = {
  registerMemberType: '1000'
}

const getters = {
  getRegisterMemberType: (state) => state.registerMemberType
}

const actions = {}

const mutations = {
  [MEMBER_TYPE_NORMAL]: (state) => {
    state.registerMemberType = '1000'
  },
  [MEMBER_TYPE_TEACHER]: (state) => {
    state.registerMemberType = '2000'
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
